import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import IosShareIcon from '@mui/icons-material/IosShare';
import PhoneIphoneIcon from '@mui/icons-material/PhoneIphone';
import EsercizioDetails from '../components/EsercizioDetails';
import { useNavigate } from 'react-router-dom';
import { Esercizio, esercizioVuoto } from '../interfaces/Esercizio';
import { MODALTYPE, ModalData, modalDataClean, ModalAlert } from '../components/ModalAlert';
import AutoTrattamentoDetails from '../components/AutoTrattamentoDetails';
import SportEducativoDetails from '../components/SportEducativoDetails';
import SpinnerODM from '../components/spinnerODM';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowOutwardIcon from '@mui/icons-material/ArrowOutward';
import EsercizioDetailsFast from './EsercizioDetailsFast';
import AutoTrattamentoDetailsFast from './AutoTrattamentoDetailsFast';
import SportEducativoDetailsFast from './SportEducativoDetailsFast';
import { useEsercizioStore } from '../utils/store';
import { isValidEsercizio } from '../interfaces/isValidFromPubished';

import { ReactComponent as AlertMessageInfo } from '../assets/icons/alertMessageinfo.svg';
import { ReactComponent as AlertMessageDisactivate } from '../assets/icons/alertMessagedisactivate.svg';





interface EditActivitiesFastProps {
  activity: number | null;
  open: boolean;
  onClose: () => void;
  refreshActivities: () => void;
  defaultType?: string;
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<{ icon: React.ReactNode; message: string }>>;
}


//const EditActivitiesFast: React.FC<EditActivitiesFastProps> = ({ token, activity, open, onClose, refreshActivities }) => {
const EditActivitiesFast: React.FC<EditActivitiesFastProps> = ({ activity, open, onClose, refreshActivities, defaultType, setSnackbarOpen, setSnackbarMessage}) => {

  const [esercizio, setEsercizio] = useState<Esercizio>(esercizioVuoto);
  const [modalData, setModalData] = useState<ModalData>(modalDataClean);
  const [activeTab, setActiveTab] = useState<number>(1);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [dirty, setDirty] = useState<boolean>(false);

  useEffect(() => {
    setLoading(true)
    if (activity) {
      const headers = new Headers();
      //if (token) {
      //  headers.set('Authorization', `Token ${token}`);
      //}
      headers.set('Accept', 'application/json');
      const requestInit: RequestInit = {
        method: 'GET',
        headers: headers,
        credentials: 'include',
      }
      fetch(`/api/v0/activity/${activity}`, requestInit)
        .then(response => response.json())
        .then(data => {
          setEsercizio(data)
        })
        .catch(error => console.error("Errore nel recupero dell'esercizio:", error));
    }
    setLoading(false)
  }, [activity]);

  useEffect(() => {
    if (esercizio) {
      ;
      switch (esercizio.type) {
        case "Exercise":
          setActiveTab(1);
          break;
        case "SelfTreatment":
          setActiveTab(2);
          break;
        case "EducationalSpot":
          setActiveTab(3);
          break;
        default:
          setActiveTab(1);
      }
    }
  }, [esercizio]);
  

  useEffect(() => {
    if (!activity && defaultType) {
      setEsercizio((prev) => ({
        ...esercizioVuoto,
        type: defaultType,
      }));
    }
  }, [activity, defaultType]);

  const handleChange = <K extends keyof Esercizio>(key: K, value: Esercizio[K]) => {
    setEsercizio((prev) => ({ ...prev, [key]: value }));
    setDirty(true);
  };

    const isValidUrl = (value: string): boolean => {
        try {
            JSON.parse(value);
            return false;
        } catch (err) {
            //console.error(err);
            return true;
        }
    }

  const salvaEsercizio = async (dati: Esercizio) => {
    setLoading(true);
    try {
      const url = esercizio.id ? `/api/v0/activity/${esercizio.id}/partial-update` : '/api/v0/activity/new';
      const method = esercizio.id ? 'PUT' : 'POST';

      let formData = new FormData();
      const dati_partial: Partial<Esercizio> = { ...dati };
      if (dati_partial.preview_image) {
        if (typeof dati_partial.preview_image === "string") {
          delete dati_partial.preview_image
        }
        if (dati_partial.preview_image instanceof File) {
          formData.append('preview_image', dati_partial.preview_image!)
        }
      }
      if (dati_partial.video) {
        if (typeof dati_partial.video === 'string') {
          delete dati_partial.video;
        }
        if (dati_partial.video instanceof File) {
          formData.append('video', dati_partial.video!);
        }
      }
      if (dati_partial.animation) {
        if (typeof dati_partial.animation === 'string') {
          delete dati_partial.animation;
        }
        if (dati_partial.animation instanceof File) {
          formData.append('animation', dati_partial.animation!);
        }
      }
      if (dati_partial.body_tracking) {
        if (!isValidUrl(dati_partial.body_tracking)){
          formData.append('body_tracking', dati_partial.body_tracking!);
        } else {
          delete dati_partial.body_tracking
        }
      }
      formData.append('fields', JSON.stringify(dati_partial));

      const headers = new Headers();
      const requestInit: RequestInit = {
        method,
        headers: headers,
        body: formData,
        credentials: 'include',
      };

      const response = await fetch(url, requestInit);

      if (!response.ok) {
        const errorData = await response.json();
        const messages = Object.entries(errorData)
          .map(([field, errors]) => `${field}: ${Array.isArray(errors) ? errors.join(', ') : errors}`)
          .join('\n');
        //throw new Error(messages);
        setSnackbarMessage({icon: <AlertMessageDisactivate/>, message: messages});
        setSnackbarOpen(true);
        setLoading(false);
        return
      }

      const data = await response.json();
      setEsercizio(data);
      setDirty(false);
      refreshActivities();

      // Mostra snackbar dopo il salvataggio
      setSnackbarMessage({icon: <AlertMessageInfo/>, message:'Elemento salvato con successo'});
      setSnackbarOpen(true);
    } catch (error: any) {
      console.error('Errore durante la chiamata API:', error);
      setModalData({
        show: true,
        title: '',
        message: error.message || "Errore durante il salvataggio dell'esercizio",
        type: MODALTYPE.OK,
      });
    }
    setLoading(false);
  };


  const salva = async () => {
    await salvaEsercizio(esercizio);
    // onClose()
  };

  const aggiornaPubblicazione = async () => {
    setLoading(true);
    const nuovoStatus = esercizio.status === 'Published' ? 'Publishable' : 'Published';
    const esercizioAggiornato = { ...esercizio, status: nuovoStatus };
    await salvaEsercizio(esercizioAggiornato);

    // Mostra snackbar dopo la pubblicazione
    setSnackbarMessage(
      nuovoStatus === 'Published' ? {icon: <AlertMessageInfo/>, message:'Elemento pubblicato con successo'} : {icon: <AlertMessageDisactivate/>, message:'Elemento disattivato in app'}
    );
    setSnackbarOpen(true);
  };

const eliminaEsercizio = async () => {
  setLoading(true);
  if (!esercizio.id) return;
  try {
    const headers = new Headers();
    const response = await fetch(`/api/v0/activity/${esercizio.id}`, {
      method: "DELETE",
      headers: headers,
      credentials: 'include',
    });
    if (!response.ok) {
      throw new Error("Errore durante l'eliminazione dell'esercizio");
    }

    refreshActivities();
    onClose();

    setSnackbarMessage({icon: <AlertMessageDisactivate />, message:"Elemento eliminato con successo"});
    setSnackbarOpen(true);
  } catch (error: any) {
    console.error("Errore durante la chiamata DELETE:", error);
    
    setSnackbarMessage(error.message || "Si è verificato un errore durante l'eliminazione dell'esercizio");
    setSnackbarOpen(true);
  }
  setLoading(false);
};

  const closeModal = () => setModalData({ ...modalData, show: false });

  if (!open) return null;
  //if (loading) return <div style={{ width: 600 }}><SpinnerODM /> </div>;

  return (
    <>
      <Box sx={{ padding: 2 }}>
        {loading ? (<SpinnerODM />) : ""}
        <div className="row justify-content-between">
          <div className='col d-flex mt-3'>
            <p style={{ whiteSpace: 'nowrap' }}>{
              {
                Exercise: "Esercizio",
                SelfTreatment: "Auto-trattamento",
                EducationalSpot: "Spot educativo"
              }[esercizio.type]
            }</p>
            <div className='ms-3'>
              {esercizio.status === "Published" ? (
                <span className="badge text-bg-success">Pubblicato</span>
              ) : (
                <span className="badge text-bg-danger">Non pubblicato</span>
              )}
            </div>
          </div>

          <div className='col text-end'>
            <button
              className="btn btn-light me-5"
              onClick={() => {
                useEsercizioStore.getState().setEsercizio(esercizio as Esercizio);
                esercizio.id ? navigate(`${esercizio.id}/edit`) : navigate(`new/edit`)
              }
              }
            >
              <ArrowOutwardIcon />
            </button>
            <button className="btn-close" onClick={() => {
              if (dirty) {
                setModalData({
                  show: true,
                  title: "Tornare indietro?",
                  message: "Se torni indietro senza salvare perderai tutte le informazioni aggiunte. Vuoi procedere?",
                  type: MODALTYPE.CONFIRM,
                  action: () => onClose(),
                });
              } else {
                onClose()
              }
            }}
            ></button>
          </div>
        </div>
        <div className="row justify-content-between mt-3">
          <div className='col-10'>
            <h3 className="text-truncate" style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {esercizio.id ? esercizio.full_name : "Nuovo Elemento"}
            </h3>
          </div>
          <div className='col text-end'>
            <button 
              className="btn btn-danger" 
              disabled={esercizio.id==null}
              onClick={() => {
              const deleteExercice = async () => {
                await eliminaEsercizio();
              }
              setModalData({
                show: true,
                title: "Elimina elemento",
                message: esercizio.status === "Published" ?
                  "Se decidi di procedere, questo elemento verrà eliminato definitivamente dall'app in tutte le sessioni in cui è presente dal backoffice." :
                  "Se decidi di procedere, questo elemento verrà eliminato definitivamente dal backoffice.",
                type: MODALTYPE.DELETE,
                action: deleteExercice
              })
            }}>
              <DeleteIcon />
            </button>
          </div>

        </div>
        <hr />

        <div className="row mt-2">
          <div className='col'>
            <button className="btn btn-light" style={{ width: "100%", whiteSpace: 'nowrap' }} onClick={salva}>
              <IosShareIcon /> Salva
            </button>
          </div>

          <div className='col'>
            <button
              className={esercizio.status === "Published" ? "btn btn-light" : "btn btn-outline-success"}
              onClick={aggiornaPubblicazione}
              disabled={esercizio.status !== "Published" && !isValidEsercizio(esercizio)}
              style={{ width: "100%", whiteSpace: 'nowrap' }}
            >
              <PhoneIphoneIcon />
              {esercizio.status === "Published" ? "Disattiva in app" : "Pubblica in app"}
            </button>
          </div>

        </div>


        {/*activity === null && (
        <div className="text-center mt-3">
          <button
            onClick={() => {
              setActiveTab(1);
              handleChange("type", "Exercise");
            }}
            className={`btn ${activeTab === 1 ? "btn-dark" : "btn-light"}`}
          >
            Esercizio
          </button>
          <button
            onClick={() => {
              setActiveTab(2);
              handleChange("type", "SelfTreatment");
            }}
            className={`btn ${activeTab === 2 ? "btn-dark" : "btn-light"}`}
          >
            Auto-trattamento
          </button>
          <button
            onClick={() => {
              setActiveTab(3);
              handleChange("type", "EducationalSpot");
            }}
            className={`btn ${activeTab === 3 ? "btn-dark" : "btn-light"}`}
          >
            Spot educativo
          </button>
        </div>
      )*/}



        {activeTab === 1 && (
          <EsercizioDetailsFast esercizio={esercizio} handleChange={handleChange} />
        )}
        {activeTab === 2 && (
          <AutoTrattamentoDetailsFast esercizio={esercizio} handleChange={handleChange} />
        )}
        {activeTab === 3 && (
          <SportEducativoDetailsFast esercizio={esercizio} handleChange={handleChange} />
        )}


        <ModalAlert modalData={modalData} onClose={closeModal} />
      </Box>
    </>
  );
};

export default EditActivitiesFast;
